"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.balanceReducer = balanceReducer;
var _types = require("./types");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  balance: {
    centValue: 0,
    formatted: undefined
  },
  bonusBalance: {
    centValue: 0,
    formatted: undefined
  },
  currency: undefined
};
function balanceReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types.UPDATE_BALANCE:
      {
        var _action$payload$balan, _action$payload$bonus, _action$payload$curre;
        // since we have nested objects, we need to use to do detailed merge of states.
        return Object.assign({}, state, _objectSpread(_objectSpread({}, state), {}, {
          balance: _objectSpread(_objectSpread({}, state.balance), {}, {
            centValue: (_action$payload$balan = action.payload.balance) === null || _action$payload$balan === void 0 ? void 0 : _action$payload$balan.centValue
          }),
          bonusBalance: _objectSpread(_objectSpread({}, state.bonusBalance), {}, {
            centValue: (_action$payload$bonus = action.payload.bonusBalance) === null || _action$payload$bonus === void 0 ? void 0 : _action$payload$bonus.centValue
          }),
          currency: (_action$payload$curre = action.payload.currency) !== null && _action$payload$curre !== void 0 ? _action$payload$curre : state.currency
        }));
      }
    case _types.UPDATE_FORMATTED_BALANCE:
      {
        return Object.assign({}, state, _objectSpread(_objectSpread({}, state), {}, {
          balance: _objectSpread(_objectSpread({}, state.balance), {}, {
            formatted: action.payload.balance.formatted
          }),
          bonusBalance: _objectSpread(_objectSpread({}, state.bonusBalance), {}, {
            formatted: action.payload.bonusBalance.formatted
          })
        }));
      }
  }
  return state;
}
//# sourceMappingURL=reducer.js.map